import StepHeader, {
    IStepHeaderStep,
} from '@/src/common/components/elements/Layout/StepHeader'
import PartnerBanner from '@/src/common/components/elements/Layout/Banners/PartnerBanner'
import { TPartnerPayload } from '@/src/modules/partners/types'
import { usePartnerTheme } from '@/src/common/contexts/PartnerThemeContext'

type TStepHeaderProps = {
    currentStep: number
    steps: IStepHeaderStep[]
    partnerData: TPartnerPayload
    message?: string
    showCart?: boolean
    showMobileNav?: boolean
}

const PartnerStepHeader = ({
    currentStep,
    steps,
    partnerData,
    message,
    showCart = true,
    showMobileNav = true,
}: TStepHeaderProps) => {
    const partnerTheme = usePartnerTheme()

    return (
        <div className={`${partnerTheme}`}>
            <StepHeader
                steps={steps}
                currentStep={currentStep}
                message={message}
                partnerData={partnerData}
                showCart={showCart}
                showMobileNav={showMobileNav}
            />
            <PartnerBanner partnerData={partnerData} />
        </div>
    )
}

export default PartnerStepHeader
